import React from 'react';

interface ServerErrorProps {
  message?: string | null;
  className?: string;
}

const ServerError: React.FC<ServerErrorProps> = ({ message, className = '' }) => {
  if (!message) return null;
  return (
    <div
      role="alert"
      className={`flex items-start gap-3 rounded-r-xl border-l-4 border-red-500 bg-red-50 p-4 dark:bg-red-900/20 ${className}`}
    >
      <svg
        className="mt-0.5 h-4 w-4 shrink-0 text-red-500 dark:text-red-400"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
      </svg>
      <p className="text-sm font-medium text-red-700 dark:text-red-400">{message}</p>
    </div>
  );
};

export default ServerError;
